import {
    AllEvents,
    DataLayerEventName,
    EntitledToView,
} from '@news-mono/web-common'
import React, { useCallback } from 'react'
import {
    StyledFootyLivesHereLink,
    StyledFootyLivesHerePromoCard,
    StyledPromoImg,
} from './FootyLivesHerePromoCard.styled'

export type FootyLivesHerePromoCardProps = {
    onEvent?: (event: AllEvents) => void
}

export const EntitledView: React.FC<FootyLivesHerePromoCardProps> = ({
    onEvent,
}) => {
    const promo = require('./assets/2026_The-Game-Tile-Logged-In-@1x.webp')

    const onLinkClick = useCallback(() => {
        onEvent?.({
            type: DataLayerEventName.selectItemEvent,
            originator: 'AFLSeasonGuidePromoCard',
            payload: {
                index: 0,
                item_brand: 'The West Australian',
                item_category: 'news/promotions',
                item_category2: 'redirect',
                item_id: 'afl_season_guide_promo_card',
                item_list_category: 'sports-afl-season-guide-promo',
                item_list_category2: 'active-promotion',
                item_name: 'AFL Season Guide Promo Card',
                item_variant: false,
                price: 0.0,
                link_text: 'Read now',
                link_url:
                    'https://thegame.com.au/play?utm_source=Acquisition&utm_medium=AFL+Page&utm_campaign=AFL+2026&utm_term=Weekly+Prize',
            },
        })
    }, [onEvent])

    return (
        <StyledFootyLivesHerePromoCard>
            <StyledFootyLivesHereLink
                to={
                    'https://thegame.com.au/play?utm_source=Acquisition&utm_medium=AFL+Page&utm_campaign=AFL+2026&utm_term=Weekly+Prize'
                }
                openExternalInNewWindow={false}
                onClick={onLinkClick}
            >
                <StyledPromoImg
                    src={promo}
                    alt="Win up to $1,000 each round with The Game. Click here to play."
                />
            </StyledFootyLivesHereLink>
        </StyledFootyLivesHerePromoCard>
    )
}

export const OpportunityView: React.FC = () => {
    const promo = require('./assets/2026_WA-Footy-Lives-Here-Tile-Logged-Out-@1x.webp')
    return (
        <StyledFootyLivesHerePromoCard>
            <StyledFootyLivesHereLink to={'/sport/afl/subscribe'}>
                <StyledPromoImg
                    src={promo}
                    alt="Sign up for a season of footy and get up to 25% off. Subscribe now."
                />
            </StyledFootyLivesHereLink>
        </StyledFootyLivesHerePromoCard>
    )
}

export const FootyLivesHerePromoCard: React.FC<FootyLivesHerePromoCardProps> =
    ({ onEvent }) => {
        return (
            <EntitledToView
                requiredAccess={{ level: 'subscriber' }}
                entitled={() => {
                    return <EntitledView onEvent={onEvent} />
                }}
                notEntitled={() => {
                    return <OpportunityView />
                }}
            />
        )
    }
